import makeStyles from "@mui/styles/makeStyles";
import { theme } from "../../../App";
const useStyles = makeStyles(() => ({
  modal: {
    width: "100vw",
    height: "100vh",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  container: {
    display: "flex",
    flexDirection: "column",
    margin: "0 auto",
    alignItems: "center",
    maxHeight: "92vh",
  },
  boxContainer: {
    display: "flex",
    flexDirection: "column",
    width: "40vw",
    height: "40vh",
    gap: "3rem",
    [theme.breakpoints.down("md")]: {
      width: "70vw",
      height: "70vh",
    },
  },
  buttonTitle: {
    fontSize: "20px",
    fontWeight: 400,
    lineHeight: "22px",
    letterSpacing: "0px",
  },
  description: {
    display: "flex",
    flexDirection: "column",
    fontSize: "24px",
    fontWeight: 300,
    lineHeight: "33px",
    letterSpacing: 0,

    [theme.breakpoints.down("md")]: {
      fontSize: "20px",
      lineHeight: "28px",
    },
  },
  resumeTypeButtonContainer: {
    display: "flex",
    flexDirection: "row",
    gap: "30px",
    // padding: "16px 0px",
    justifyContent: "space-between",
    [theme.breakpoints.down("sm")]: {
      flexDirection: "column",
    },
  },
  resumeType: {
    display: "flex",
    flexDirection: "column",

    textAlign: "left",
    height: "20vh",
    borderRadius: 8,
    padding: "20px",
    cursor: "pointer",
    position: "relative",
    gap: "8px",
    "&:focus-within": {
      boxShadow: "0 0px 7px 0 rgba(0, 113, 206, 0.2)",
    },
  },
  selectedOn: {
    border: "2px solid #0071ce",
  },
  selectedOff: {
    border: "2px solid #dadce0",
  },
  resumeInput: {
    position: "absolute",
    opacity: 0,
  },
  continueBtn: {
    borderRadius: "100px",
    width: "8rem",
    alignSelf: "flex-end",
  },
}));
export default useStyles;
